import { render, staticRenderFns } from "./RadioButtonLabel.vue?vue&type=template&id=4afb425e&"
import script from "./RadioButtonLabel.vue?vue&type=script&lang=ts&"
export * from "./RadioButtonLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports